// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Index from '../.components/index.vue'
import Show from '../.components/show.vue'

const main_router = 'user_logs'
const show_router = 'user_log'

const router = [
    {
        path: '',
        component: Index,
        name: 'user_logs',
        meta: {
            api_name: 'api_v1_provider_logs',
            breadcrumb: [main_router]
        }
    },
    {
        path: 'show/:identity',
        component: Show,
        name: 'user_log',
        meta: {
            api_name: 'api_v1_provider_log',
            breadcrumb: [main_router, show_router]
        }
    },
]

export default router
